const initialState = {
  meetType: null,
  phone: null,
  shopperUsername: null,
  effectiveDate: null,
  shopperName: '',
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'SET_SOFTPHONE_FIELD':
      return { ...state, ...action.payload };
    case 'CLEAR':
      return { ...initialState };
    default:
      return state;
  }
};
